import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Landagroup_logo.png';

export default function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false); // État pour le menu burger

  const navItems = [
    { path: '/', label: 'Accueil' },
    { path: '/services', label: 'Nos Services' },
    { path: '/le-groupe', label: 'Le Groupe' },
    { path: '/contact', label: 'Contact', isButton: true }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Fonction pour fermer le menu quand on clique sur un lien
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      <div className="container nav-content">
        
        {/* BLOC LOGO */}
        <Link to="/" className="brand-wrapper" onClick={closeMenu}>
          <img src={logo} alt="Logo LandaGroup" className="brand-img" />
          <span className="brand-text">LandaGroup</span>
        </Link>
        
        {/* BOUTON BURGER (Visible uniquement sur mobile via CSS) */}
        <button 
          className="burger-btn" 
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Ouvrir le menu"
        >
          <span className={`burger-bar ${isOpen ? 'open' : ''}`}></span>
          <span className={`burger-bar ${isOpen ? 'open' : ''}`}></span>
          <span className={`burger-bar ${isOpen ? 'open' : ''}`}></span>
        </button>

        {/* LIENS DE NAVIGATION */}
        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={closeMenu} // Ferme le menu au clic
              className={item.isButton ? 
                `btn ${isActive(item.path) ? 'btn-primary' : 'btn-outline'}` 
                : `nav-link ${isActive(item.path) ? 'active' : ''}`
              }
              // On retire le style inline pour le gérer en CSS responsive
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}